import cacheUtil from '@/utils/cacheUtil'
import { validate } from '@/utils/loginAuth';
import { permissionsApi, orgApi } from "@/services";
const user = {
    namespaced: true,
    state: {
        //  公发部中标价预算表    8107506    葛燕
        //  发货政策    8107506    葛燕
        //  渠道价格预算表    8104646    王萌萌
        //  渠道价格预算表(大区)    2000915    郑攀崎
        //  纯销价格预算表    8104487    崔振江
        //  纯销价格预算表(大区)    8106828    张倩
        //  基层价格预算表    8107144    栾国秀
        //  基层价格预算表(大区)    8101774    徐静
        //  市场部价格预算表    8107012    赵文华
        //  市场部价格预算表(大区)    8101139    方红娇
        //  渠道收入预算表    8104646    王萌萌
        //  渠道收入预算表(大区)    2000915    郑攀崎
        //  纯销收入预算表    8104487    崔振江
        //  纯销收入预算表(大区)    8106828    张倩
        //  基层收入预算表    8107144    栾国秀
        //  基层收入预算表(大区)    8101774    徐静
        //  市场部收入预算表    8107012    赵文华
        //  市场部收入预算表(大区)    8101139    方红娇
        //  挑战指标预算表    8107053    仲文茜
        //  原料药销售预算表    8102586    杨冬青
        //  原料药出口及代加工预算表    8104052    曹婧
        //  二次议价费用预算表    8104487    崔振江
        //  二次议价费用预算表(大区)    8106828    张倩
        //  返利费用预算表  8107144    栾国秀
        //  返利费用预算表(大区)    8101774    徐静
        //  生产    生产产量预算表    8107506
        //  生产    中试需求预算表    8107506
        //  采购    原材料采购预算表    8104646
        //  采购    原材料价格预算表    8104646
        //  人事    公司薪酬预算表    8107144
        //  人事    研究院奖金预算    8107144
        //  人事    销售奖金预算    8107053
        //  人事    高管奖金预算    8106828  8105102
        //  人事    归口福利费预算表    8107053
        //  财务    资金预算表    8104487
        //  财务    税金预算表    8104487
        //  报表  8104491
        //  高级管理员  8104491
        //  运营人员  8107300

        // 管理    归口设备     归口设备预算表
        // 信息技术中心	8102725
        // 集团-设备部	2000915
        // 润众-设备部	8106828
        // 顺欣-设备部	8101774
        // 总裁办公室	8107012
        // 营销支持部	8107053
        // 润众办公室	8102586
        //  研发    项目    未立项研发项目预算表    8104487
        //  研发    项目    已立项研发项目预算表    8101139
        //  工程    项目    工程项目预算表    8101139
        //  市场    项目    市场项目预算表    8101139
        //  医学研究    项目    医学研究项目预算表    8101139
        //  其他    项目    其他项目预算表    8101139
        //  信息    项目    信息项目预算表    8101139
        //  BD    项目    BD项目预算表    8101139
        //  政府拨款    项目    政府拨款项目预算表    8101139
        //  部门设备  8101139
        //  部门费用  8104487  8107144 8106828
        //  部门人员  8104487
        //基础返利 8107144
        // 渠道三级 2000791 基层 2000605 纯销 1100003
        // 财务反馈 8604695
        // 归口审核 8105102
        // dev 财务反馈和归口审核8107053
        account: '',// 8107053 【新品挑战】 8107506【价格发货】 8101139 【项目】
        token: '',
        userInfo: {},
        userMenu: [],
        userPower: [],
        resourceCode: 'PriceControl',
        isMenuShow: true
    },
    getters: {
        getUserInfo: (state) => state.account == '' ? null : state.account,
        getToken: (state) => state.token == '' ? null : state.token
    },
    mutations: {
        setUserInfo: (state, account) => {
            state.account = account;
        },
        setToken: (state, token) => {
            state.token = token;
        },
        setUserPower: (state, list) => {
            state.userPower = list;
        },
        setResourceCode: (state, code) => {
            state.resourceCode = code;
        },
        setUserMenu: (state, menus) => {
            state.userMenu = menus;
        },
        setUserInfoData: (state, user) => {
            state.userInfo = user;
        },
        setMenuState: (state, isShow) => {
            state.isMenuShow = isShow;
        },
    },
    actions: {
        toLoginGetUsrInfo({ commit }) {//判断是否登陆并获取用户信息
            return validate().then(data => {
                // console.log(data);
                let account = data.user;
                let token = data.token;
                commit('setUserInfo', account);
                commit('setToken', token);
                cacheUtil.set('account', account);
                // cacheUtil.set('token', token);
                return data;
            });
        },
        settoLoginGetUsrInfo({ commit }, param) {//判断是否登陆并获取用户信息
            let account = param.user;
            let token = param.token;
            commit('setUserInfo', account);
            commit('setToken', token);
            cacheUtil.set('account', account);
            return { account: account, token: token };
        },
        getUserInfo({ commit }, param) {
            return orgApi.getUserInfo(param).then(res => {
                if (res && res.responseData) {
                    commit('setUserInfoData', res.responseData[0]);
                }
                return res;
            });
        },
        getUserMenu({ commit }, param) {
            return permissionsApi.getUserMenu(param).then(res => {
                if (res && res.responseData) {
                    let menus = [];
                    if (res.responseData && res.responseData.length > 0) {
                        res.responseData.forEach(ele => {
                            let mChildren = [];
                            if (ele.childMenus && ele.childMenus.length > 0) {
                                ele.childMenus.forEach(item => {
                                    mChildren.push({
                                        path: item.resourceUrl,
                                        meta: {
                                            resourceCode: item.resourceCode,
                                            name: item.resourceName,
                                            isMenu: true
                                        }
                                    });
                                });
                                let path = '';
                                if (ele.resourceUrl == '' || ele.resourceUrl == null) {
                                    path = 'A_' + ele.resourceCode;
                                } else if (ele.resourceUrl == '#') {
                                    path = ele.resourceCode + '#';
                                } else {
                                    path = ele.resourceUrl;
                                }
                                menus.push({
                                    path: path,
                                    meta: {
                                        resourceCode: ele.resourceCode,
                                        name: ele.resourceName,
                                        isMenu: true
                                    },
                                    children: mChildren
                                });
                            } else {
                                let path = '';
                                if (ele.resourceUrl == '' || ele.resourceUrl == null) {
                                    path = 'B_' + ele.resourceCode;
                                } else if (ele.resourceUrl == '#') {
                                    path = ele.resourceCode + '#';
                                } else {
                                    path = ele.resourceUrl;
                                }
                                menus.push({
                                    path: path,
                                    meta: {
                                        resourceCode: ele.resourceCode,
                                        name: ele.resourceName,
                                        isMenu: true
                                    }
                                });
                            }

                        });
                    }
                    commit('setUserMenu', menus);
                }
                return res;
            });
        },
        getUserAction({ commit }, param) {
            return permissionsApi.getUserAction(param).then(res => {
                if (res && res.responseData) {
                    commit('setUserPower', res.responseData);
                }
                return res;
            });
        },
        changeResourceCode({ commit }, code) {
            commit('setResourceCode', code);
        },
        changeMenuState({ commit }, isShow) {
            commit('setMenuState', isShow);
        }
    }
}

export default user;
